import { ExplorerDetailDataPropsType } from 'src/views/Service/Explorer/Detail'
import Div from 'src/components/atomic/atom/Div'
import Span from 'src/components/atomic/atom/Span'
import Section from 'src/components/atomic/atom/Section'
import { ColorHandler } from 'src/utils/style.utils'
import Svg from 'src/components/atomic/atom/Svg'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'

const ExplorerDetailPagination = (props: { data: ExplorerDetailDataPropsType }) => {
  const { curPage, paginationHandler, ResultPageList } = props.data
  const { processFileInfo } = useAppSelector((state: RootState) => state.explorerFileList)
  const LeftArrowStyle = {
    width: '24px',
    visibility: curPage <= 5 ? 'hidden' : 'unset',
  }
  const RightArrowStyle = {
    width: '24px',
    visibility:
      (processFileInfo.p_filePageLength as number) > 5 &&
      !ResultPageList?.includes(processFileInfo.p_filePageLength as number)
        ? 'unset'
        : 'hidden',
  }

  return (
    <Section display={'flex'} $margin={'40px auto 36px auto'} $gap={'12px'} width={'320px'}>
      <Div display={'flex'} $gap={'12px'} $margin={'0 auto'}>
        <Svg
          name={'arrow'}
          width={'11'}
          height={'20'}
          rotate={180}
          style={LeftArrowStyle}
          onClick={() => paginationHandler(ResultPageList[0] - 1)}
        />
        {ResultPageList?.map((element) => (
          <Span
            key={element}
            width={'40px'}
            $line_height={'40px'}
            option={'mediumLarge_bold'}
            color={ColorHandler(curPage === element, 'white_black30')}
            onClick={() => paginationHandler(element)}
            style={{
              borderRadius: '12px',
              backgroundColor: ColorHandler(curPage === element, 'brand_white'),
            }}
          >
            {element}
          </Span>
        ))}
        <Svg
          name={'arrow'}
          width={'11'}
          height={'20'}
          onClick={() => {
            paginationHandler(ResultPageList[ResultPageList?.length - 1] + 1)
            window.scrollTo(0, 0)
          }}
          style={RightArrowStyle}
        />
      </Div>
    </Section>
  )
}
export default ExplorerDetailPagination
